import mobileAdjustment from "../GeneralMobileAdjustments";

class MobileMaskedTextControlView {

    constructor() { }

    afterRender(control){
        let element = mobileAdjustment.adjustMobileControl(control);
        element.find("div:first").css("width","100%");
       const fontSize = control.model.get('fontSize');

        Array.from(element.find('label'))
             .forEach(label => {
                 label.style.fontSize = `${fontSize}px`;
                 label.style.height = `${fontSize}px`;
                 label.style.width = `15px`;
             });

    }
}

const mobileMaskedTextControlView = new MobileMaskedTextControlView();
export default mobileMaskedTextControlView;